import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { ApiResponse, getApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
// import { cleanEmpty } from 'utils/genericFunctions';
import { ConsultarParametroLocalidadesSiglaRequest, Types } from './types';

// ACTIONS
import {
	consultarParametroLocalidadesSiglaSuccess,
	consultarParametroLocalidadesSiglaFailure,
} from './actions';

function* consultarParametroLocalidadesSiglaSaga(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: ConsultarParametroLocalidadesSiglaRequest } =
		request;

	const body = {
		idOrgao: payload.idOrgao,
	};
	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_SGU_API,
		`v2/parametros-localidades/${payload.sigla}/localidades`,
		body,
	);

	if (response.status === 200) {
		yield put(consultarParametroLocalidadesSiglaSuccess(response));
	} else {
		yield put(consultarParametroLocalidadesSiglaFailure());
	}
}

export default all([
	takeLatest(
		Types.CONSULTAR_PARAMETRO_LOCALIDADES_SIGLA,
		consultarParametroLocalidadesSiglaSaga,
	),
]);
